import { z } from 'zod'
import { TinyResidentSchema } from '../resident'
import { CardAttachmentIdSchema, CompanyIdSchema, UserIdSchema } from '../ids'
import { AuditPropsSchema } from '../common'

export const CardEntityIdSchema = z.union([CompanyIdSchema, UserIdSchema])
export type CardEntityId = z.infer<typeof CardEntityIdSchema>

export const CardLinkSchema = z.object({
  label: z.string().optional(),
  url: z.string(),
})
export type CardLink = z.infer<typeof CardLinkSchema>

export const CardGalleryFileSchema = z.object({
  attachmentId: CardAttachmentIdSchema,
  url: z.string(),
})
export type CardGalleryFile = z.infer<typeof CardGalleryFileSchema>

export const CardSlugSchema = z
  .string()
  .min(3)
  .regex(/^[A-Za-z0-9._~-]+$/)
  .transform((slug) => slug.toLowerCase())
  .meta({
    id: 'cardSlug',
    title: 'Card Slug',
    description: 'The public slug used to look up a card',
  })
export type CardSlug = z.infer<typeof CardSlugSchema>

export const CardBaseSchema = z.object({
  ...AuditPropsSchema.shape,
  slug: CardSlugSchema,
})

export const CardResidentSchema = TinyResidentSchema.pick({ firstName: true, lastName: true, businessName: true })
export type CardResident = z.infer<typeof CardResidentSchema>
